// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Clients_page__ro\\+J4 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.Clients_headerBar__EoUew {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 14px 22px;
}
.Clients_title__mBwl3 {
  font-size: 26px;
  font-weight: 700;
  color: var(--dylo-ink);
  margin: 0;
}
.Clients_headerActions__RW7F\\+ {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.Clients_newBtn__aPGyx {
  white-space: nowrap;
  background: var(--dylo-orange) !important;
  border: none !important;
}
.Clients_newBtn__aPGyx:hover {
  background: var(--dylo-orange-hover) !important;
}
.Clients_search__4WPl8 {
  width: 300px;
  max-width: 100%;
}

/* ===== Grid de clientes ===== */
.Clients_grid__bdYrq {
  display: grid;
  /* \`min(290px, 100%)\` (21-oct-2026): en un teléfono angosto la tarjeta mínima de 290 px no cabía. En escritorio, igual. */
  grid-template-columns: repeat(auto-fit, minmax(min(290px, 100%), 1fr));
  gap: 14px;
}

.Clients_clientCard__iZWNN {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 18px 20px;
  animation: Clients_dylo-fade-in__ueGKV 0.28s ease both;
  transition: transform 0.15s ease, border-color 0.15s ease;
}
.Clients_clientCard__iZWNN:hover {
  transform: translateY(-3px);
  border-color: var(--dylo-orange);
}
/* Nombre + modo. Ver la nota en Clients.tsx de por qué el modo vive aquí. */
.Clients_cardHead__qK4Co {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  /* La altura mínima se mueve del nombre al renglón: así las tarjetas siguen
     alineadas entre sí, con o sin insignia, y con nombres de una o dos líneas. */
  min-height: 39px;
}

.Clients_clientName__JIU\\+8 {
  font-size: 15px;
  font-weight: 700;
  color: var(--dylo-ink);
  margin: 0;
  line-height: 1.3;
  /* Cede el ancho a la insignia en lugar de empujarla fuera de la tarjeta. */
  min-width: 0;
  overflow-wrap: anywhere;
}

.Clients_stats__115Ns {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 10px;
}
.Clients_stat__9Tq4V {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: var(--dylo-muted);
}
.Clients_stat__9Tq4V svg {
  color: var(--dylo-teal-700);
  flex-shrink: 0;
}
.Clients_stat__9Tq4V b {
  color: var(--dylo-ink);
  font-weight: 700;
}

.Clients_cardFoot__Eg\\+yT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: auto;
  background: var(--dylo-field-bg);
  border: 1px solid var(--dylo-field-border);
  border-radius: 999px;
  padding: 5px 6px 5px 16px;
}
.Clients_statusDot__tS0hR {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--dylo-ink);
}
.Clients_statusDot__tS0hR::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.Clients_active__shyq2::before {
  background: #2aad27;
}
.Clients_inactive__efnsM {
  color: var(--dylo-danger);
}
.Clients_inactive__efnsM::before {
  background: var(--dylo-danger);
}

/* Sin dato de estado. En gris y en cursiva para que se lea como "todavía no",
   no como un estado más del cliente. */
.Clients_statusUnknown__i1ADf {
  font-size: 12px;
  font-style: italic;
  color: var(--dylo-muted);
  white-space: nowrap;
}

.Clients_detailBtn__77B9x {
  padding: 7px 20px !important;
  font-size: 12.5px !important;
  background: var(--dylo-orange) !important;
  border: none !important;
  border-radius: 999px !important;
  flex-shrink: 0;
}
.Clients_detailBtn__77B9x:hover {
  background: var(--dylo-orange-hover) !important;
}

.Clients_empty__TO1\\+J {
  padding: 40px;
  text-align: center;
  color: var(--dylo-muted);
  font-size: 14px;
  margin: 0;
}

.Clients_createForm__79Wgd {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.Clients_createLabel__I4Gcm {
  font-size: 13px;
  font-weight: 600;
  color: var(--dylo-text);
}
.Clients_createErr__ZFQ3C {
  font-size: 12.5px;
  color: var(--dylo-danger);
}

/* Explica por qué el botón Create está deshabilitado.
   📌 En color apagado y NO en rojo: no es un error de lo que se escribió, es un paso
   que falta. Con el color de error se leería como que algo se hizo mal. */
.Clients_createHint__Lw-76 {
  font-size: 12.5px;
  line-height: 1.45;
  color: var(--dylo-muted);
}

.Clients_skRounded__7HTsF {
  border-radius: 999px !important;
}

/* \`.footState\` se quitó: agrupaba el estatus con la insignia de modo en el pie, y
   era justo lo que descuadraba la tarjeta —no cabían los tres elementos, así que el
   grupo se partía en dos renglones—. El modo se movió al renglón del nombre. */
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Clients/Clients.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,uBAAuB;AACzB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,yHAAyH;EACzH,sEAAsE;EACtE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,sDAAuC;EACvC,yDAAyD;AAC3D;AACA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;AACA,4EAA4E;AAC5E;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR;iFAC+E;EAC/E,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,2EAA2E;EAC3E,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,0CAA0C;EAC1C,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;;AAEA;uCACuC;AACvC;EACE,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,yCAAyC;EACzC,uBAAuB;EACvB,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;0EAE0E;AAC1E;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;+EAE+E","sourcesContent":[".page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.headerBar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 14px 22px;\n}\n.title {\n  font-size: 26px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  margin: 0;\n}\n.headerActions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.newBtn {\n  white-space: nowrap;\n  background: var(--dylo-orange) !important;\n  border: none !important;\n}\n.newBtn:hover {\n  background: var(--dylo-orange-hover) !important;\n}\n.search {\n  width: 300px;\n  max-width: 100%;\n}\n\n/* ===== Grid de clientes ===== */\n.grid {\n  display: grid;\n  /* `min(290px, 100%)` (21-oct-2026): en un teléfono angosto la tarjeta mínima de 290 px no cabía. En escritorio, igual. */\n  grid-template-columns: repeat(auto-fit, minmax(min(290px, 100%), 1fr));\n  gap: 14px;\n}\n\n.clientCard {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 18px 20px;\n  animation: dylo-fade-in 0.28s ease both;\n  transition: transform 0.15s ease, border-color 0.15s ease;\n}\n.clientCard:hover {\n  transform: translateY(-3px);\n  border-color: var(--dylo-orange);\n}\n/* Nombre + modo. Ver la nota en Clients.tsx de por qué el modo vive aquí. */\n.cardHead {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  /* La altura mínima se mueve del nombre al renglón: así las tarjetas siguen\n     alineadas entre sí, con o sin insignia, y con nombres de una o dos líneas. */\n  min-height: 39px;\n}\n\n.clientName {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  margin: 0;\n  line-height: 1.3;\n  /* Cede el ancho a la insignia en lugar de empujarla fuera de la tarjeta. */\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.stats {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  gap: 10px;\n}\n.stat {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  color: var(--dylo-muted);\n}\n.stat svg {\n  color: var(--dylo-teal-700);\n  flex-shrink: 0;\n}\n.stat b {\n  color: var(--dylo-ink);\n  font-weight: 700;\n}\n\n.cardFoot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: auto;\n  background: var(--dylo-field-bg);\n  border: 1px solid var(--dylo-field-border);\n  border-radius: 999px;\n  padding: 5px 6px 5px 16px;\n}\n.statusDot {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--dylo-ink);\n}\n.statusDot::before {\n  content: '';\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.active::before {\n  background: #2aad27;\n}\n.inactive {\n  color: var(--dylo-danger);\n}\n.inactive::before {\n  background: var(--dylo-danger);\n}\n\n/* Sin dato de estado. En gris y en cursiva para que se lea como \"todavía no\",\n   no como un estado más del cliente. */\n.statusUnknown {\n  font-size: 12px;\n  font-style: italic;\n  color: var(--dylo-muted);\n  white-space: nowrap;\n}\n\n.detailBtn {\n  padding: 7px 20px !important;\n  font-size: 12.5px !important;\n  background: var(--dylo-orange) !important;\n  border: none !important;\n  border-radius: 999px !important;\n  flex-shrink: 0;\n}\n.detailBtn:hover {\n  background: var(--dylo-orange-hover) !important;\n}\n\n.empty {\n  padding: 40px;\n  text-align: center;\n  color: var(--dylo-muted);\n  font-size: 14px;\n  margin: 0;\n}\n\n.createForm {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.createLabel {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--dylo-text);\n}\n.createErr {\n  font-size: 12.5px;\n  color: var(--dylo-danger);\n}\n\n/* Explica por qué el botón Create está deshabilitado.\n   📌 En color apagado y NO en rojo: no es un error de lo que se escribió, es un paso\n   que falta. Con el color de error se leería como que algo se hizo mal. */\n.createHint {\n  font-size: 12.5px;\n  line-height: 1.45;\n  color: var(--dylo-muted);\n}\n\n.skRounded {\n  border-radius: 999px !important;\n}\n\n/* `.footState` se quitó: agrupaba el estatus con la insignia de modo en el pie, y\n   era justo lo que descuadraba la tarjeta —no cabían los tres elementos, así que el\n   grupo se partía en dos renglones—. El modo se movió al renglón del nombre. */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Clients_page__ro+J4`,
	"headerBar": `Clients_headerBar__EoUew`,
	"title": `Clients_title__mBwl3`,
	"headerActions": `Clients_headerActions__RW7F+`,
	"newBtn": `Clients_newBtn__aPGyx`,
	"search": `Clients_search__4WPl8`,
	"grid": `Clients_grid__bdYrq`,
	"clientCard": `Clients_clientCard__iZWNN`,
	"dylo-fade-in": `Clients_dylo-fade-in__ueGKV`,
	"cardHead": `Clients_cardHead__qK4Co`,
	"clientName": `Clients_clientName__JIU+8`,
	"stats": `Clients_stats__115Ns`,
	"stat": `Clients_stat__9Tq4V`,
	"cardFoot": `Clients_cardFoot__Eg+yT`,
	"statusDot": `Clients_statusDot__tS0hR`,
	"active": `Clients_active__shyq2`,
	"inactive": `Clients_inactive__efnsM`,
	"statusUnknown": `Clients_statusUnknown__i1ADf`,
	"detailBtn": `Clients_detailBtn__77B9x`,
	"empty": `Clients_empty__TO1+J`,
	"createForm": `Clients_createForm__79Wgd`,
	"createLabel": `Clients_createLabel__I4Gcm`,
	"createErr": `Clients_createErr__ZFQ3C`,
	"createHint": `Clients_createHint__Lw-76`,
	"skRounded": `Clients_skRounded__7HTsF`
};
export default ___CSS_LOADER_EXPORT___;
